import React from "react";
import { Container, Title, Description } from "../general";
import TeamList from "./TeamList";
import { TEAM } from "../../data/team";

const OurTeam = () => {
  return (
    <Container className="text-center py-10" id="our-team">
      <Title fontSize="3xl">Our Team</Title>
      <Description className="mb-8">
        We are two high schoolers with a passion for productivity and software
      </Description>
      <TeamList list={TEAM} />
    </Container>
  );
};

export default OurTeam;
